"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAlertModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var BaseModal_1 = require("./BaseModal");
var portal_core_1 = require("@ferry/portal-core");
var BaseAlertModal = /** @class */ (function (_super) {
    __extends(BaseAlertModal, _super);
    function BaseAlertModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: true
        };
        return _this;
    }
    BaseAlertModal.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(BaseModal_1.BaseModal, { modalClassName: "my-2 info-modal", modalHeader: this.renderModalHeader(), modalBodyClassName: "pt-0 overflow-auto", modalBody: this.props.modalBody, modalFooterClassName: "d-flex flex-column", modalFooter: this.renderModalFooter(), onClose: this.props.onClose, isOpen: this.props.showModal }));
    };
    BaseAlertModal.prototype.renderModalHeader = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "info-popup-title", children: [(0, jsx_runtime_1.jsx)("img", { src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/alert-popup.svg"), alt: "Attention" }), (0, jsx_runtime_1.jsx)("div", { className: "font-weight-bold", children: this.props.modalTitle })] }));
    };
    BaseAlertModal.prototype.renderModalFooter = function () {
        return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary width-md-250 mb-1 btn-next-no-arrow", onClick: this.props.onClose, children: "Ok, I understand" }));
    };
    return BaseAlertModal;
}(React.Component));
exports.BaseAlertModal = BaseAlertModal;
//# sourceMappingURL=BaseAlertModal.js.map